import axios from "axios";
import { apiCollection } from './apiCollection'


export const listPlantsApi = (plant) => {
    try {
        const response = axios
            .get(apiCollection.plantsList(plant), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const plantDetail = (plantID) => {
    try {
        const response = axios.get(apiCollection.plantDetailApi(plantID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const updatePlantAPI = (payload) => {
    try {
        const response = axios.put(apiCollection.plantEditApi(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

export const BulkSearchApi = (payload) => {
    try {
        const response = axios.post(apiCollection.bulkSearch(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

export const DispatchSearchApi = (payload) => {
    try {
        const response = axios.post(apiCollection.dispatchBulkSearch(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

export const plantData = (value) => {
    try {
        const response = axios
            .get(apiCollection.plantsData(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const listVinsApi = () => {
    try {
        const response = axios
            .get(apiCollection.vinsList(), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsDetailsApi = (value) => {
    try {
        const response = axios
            .get(apiCollection.vinsDetails(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsCountApi = (value) => {
    try {
        const response = axios
            .get(apiCollection.vinsCount(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsParkingStatusAPI = (value) => {
    try {
        const response = axios
            .get(apiCollection.vinsParkingStatus(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsDispatchHistoryAPI = (plant, limit, offset, filter, search) => {
    // console.log("TOken", window.keycloak)
    try {
        // const domainURL = "https://https://079f-114-143-107-6.in.ngrok.io/";
        // console.log("%c adata inside vindetails = ", "color:red", limit, offset, filter, search,
        //     `${domainURL}api/view_history_dispatch?limit=${limit}&offset=${offset}&filter=${filter}&search=${search}`)
        // console.log(apiCollection.vinsDispatchHistory(plant, limit, offset, filter, search))
        const response = axios
            .get(apiCollection.vinsDispatchHistory(plant, limit, offset, filter, search), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsAPI = (plant, limit, offset, filter, search) => {
    try {
        const response = axios
            .get(apiCollection.vin(plant, limit, offset, filter, search), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const vinsAgingCountAPI = () => {
    try {
        const response = axios
            .get(apiCollection.vinsAgingCount(), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        // .get("https://bb52-114-143-107-6.in.ngrok.io/api/aging_all_vins")

        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const dispatchVinHistoryFilterAPI = (value) => {
    try {
        const response = axios
            .get(apiCollection.vinsDispatchHistoryFilter(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const dispatchHistorySearchAPI = (value) => {
    try {
        const response = axios
            .get(apiCollection.dispatchHistorySearch(value), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const areaListAPI = (limit, offset, plant, search) => {
    try {
        const response = axios
            .get(apiCollection.areaList(limit, offset, plant, search), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const createAreaAPI = (payload) => {
    try {
        const response = axios.post(apiCollection.createArea(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

export const updateAreaAPI = (payload) => {
    try {
        const response = axios.put(apiCollection.editArea(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

export const areaDetails = (areaID) => {
    try {
        const response = axios
            .get(apiCollection.areaDetailsAPI(areaID), {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            })
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export const areaDelete = (areaID) => {
    try {
        // console.log(areaID)
        const response = axios.delete(apiCollection.areaDeleteAPI(areaID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        // console.log(" = ", response)
        return response;
    }
    catch (error) {
        return error;
    }
}

export const zoneListing = (limit, offset, filter, search, plant) => {
    try {
        const response = axios.get(apiCollection.zoneList(limit, offset, filter, search, plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const zoneDelete = (zoneID) => {
    try {
        // console.log(zoneID)
        const response = axios.delete(apiCollection.zoneDeleteAPI(zoneID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        // console.log(" = ", response)
        return response;
    }
    catch (error) {
        return error;
    }
}

export const zoneDetail = (zoneID) => {
    try {
        const response = axios.get(apiCollection.zoneDetailApi(zoneID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}


export const getAreaDetails = (areaID) => {
    try {
        const response = axios.get(apiCollection.getAreaApi(areaID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const getPlantDetails = (plantID) => {
    try {
        const response = axios.get(apiCollection.getPlantDetailsApi(plantID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const getAreaZone = (plantID) => {
    try {
        const response = axios.get(apiCollection.getAreazoneApi(plantID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const getzoneDetails = (zoneID) => {
    try {
        const response = axios.get(apiCollection.getZoneDetailsApi(zoneID), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const vinAgingListing = (plant, limit, offset, filter, search) => {
    try {
        const response = axios.get(apiCollection.vinsAgingList(plant, limit, offset, filter, search),
            {
                headers: {
                    'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
                }
            });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const zoneUpdate = (payload) => {
    try {
        const response = axios.put(apiCollection.zoneUpdateApi(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const zoneCreate = (payload) => {
    try {
        const response = axios.post(apiCollection.zoneCreateApi(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

export const bulkZoneDelete = (payload) => {
    try {
        // console.log(payload)
        const response = axios.post(apiCollection.bulkZoneDeleteAPI(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        // console.log(" = ", response)
        return response;
    }
    catch (error) {
        return error;
    }
}

export const bulkAreaDelete = (payload) => {
    try {
        // console.log(payload)
        const response = axios.post(apiCollection.bulkAreaDeleteAPI(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        // console.log(" = ", response)
        return response;
    }
    catch (error) {
        return error;
    }
}

// authentication
export const getUserProfile = async () => ({});
export const buildErrorMessage = error => {
    console.log({ error });
    let message;
    if (!error) {
        return message;
    }

    if (error.response) {
        message =
            `Request ${error.response.config?.method.toUpperCase()}' '${error.response.config?.url
            }, params:${JSON.stringify(error.response.config?.params)
            } failed, status:${error.response.status}`;
    } else {
        message = error.message;

        if (error.stack) {
            message += ` sourceFunction:${error.stack.split('\n')[1]}`;
        }
        if (error.config) {
            message += ` request: ${error.config.method} ${error.config.url}`;
        }
    }
    return message || JSON.stringify(error);
};


// usage analytics
export const postUsageAnalytics = (payload) => {
    try {
        // console.log("payload = ",payload)
        const response = axios.post(apiCollection.createAnaltics(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}
export const getUsageAnalytics = (plant, filter, limit, offset) => {
    try {
        // console.log("payload = ",payload)
        const response = axios.get(apiCollection.getAnaltics(plant, filter, limit, offset), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

// driver
export const createDriverApi = (payload) => {
    // console.log("payload = ",payload)
    try {
        const response = axios.post(apiCollection.createDriver(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}
export const driverListApi = (limit, offset, plant) => {
    try {
        const response = axios.get(apiCollection.driverList(limit, offset, plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}
export const resetDriverPinApi = (payload) => {
    try {
        const response = axios.post(apiCollection.resetDriverPin(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}
export const getDriverDetailsAPI = (driverId) => {
    try {
        const response = axios.get(apiCollection.getDriverDetails(driverId), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}
export const bulkDriverDeleteAPI = (payload) => {
    try {
        const response = axios.post(apiCollection.bulkDriverDelete(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

// device
export const createDeviceApi = (payload) => {
    // console.log("payload = ",payload)
    try {
        const response = axios.post(apiCollection.createDevice(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}
export const deviceListApi = (limit, offset, plant, search) => {
    // console.log("payload = ",payload)
    try {
        const response = axios.get(apiCollection.deviceList(limit, offset, plant, search), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}
export const getDeviceDetailsAPI = (deviceId) => {
    try {
        const response = axios.get(apiCollection.getDeviceDetails(deviceId), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}
export const bulkDeviceDeleteAPI = (payload) => {
    try {
        const response = axios.post(apiCollection.bulkDeviceDelete(), payload, {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        return error;
    }
}

// device assignment
export const deviceAsnApi = (limit, offset, plant, filter) => {
    try {
        const response = axios.get(apiCollection.deviceAsnList(limit, offset, plant, filter), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

// dashboard analytics
export const dashboardAnalyticsApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalytics(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

// api for dashhboard Parked Vins
export const dashboardAnalyticsParkedVINApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalyticsParkedVIN(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

// api for area parking capacity
export const dashboardAnalyticsAreaParkingCapacityApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalyticsAreaParkingCapacity(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

// api for overspeed count 
export const dashboardAnalyticsOverspeedCountApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalyticsOverspeedCount(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

//api for trips (daily)
export const dashboardAnalyticsTripDailyApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalyticsTripDaily(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}

//api for trips (weekly)
export const dashboardAnalyticsTripWeeklyApi = (plant) => {
    try {
        const response = axios.get(apiCollection.dashboardAnalyticsTripWeekly(plant), {
            headers: {
                'Authorization': `Bearer ${window.keycloak && window.keycloak.token}`
            }
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return error;
    }
}